import React, { useContext } from "react";
import "./ProductsHome.css";
import "./ResponsiveProducts.css";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination,Mousewheel } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { dataContext } from "../../context/DataContextProviderr";
// import required modules

const ProductsHome = ({ setIndexProducts }) => {
  const { allProducts } = useContext(dataContext);
  const navigate = useNavigate();
  const NavigateHandler = (path, index) => {
    navigate(path);
    setIndexProducts(index);
  };
  const tbldata = require("../../data.json");
  return (
    <div className="products-home" id="product-slider">
      <Swiper
        direction={"vertical"}
        pagination={{
          clickable: true,
        }}
        // autoplay={{
        //   delay: 7000,
        //   disableOnInteraction: false,
        // }}
        breakpoints={{
          320:{
            direction:"horizontal"
          },
          1025:{
            direction:"vertical"
          }
        }}
        dir="ltr"
        mousewheel={true}
        modules={[Autoplay, Pagination,Mousewheel]}
        className="mySwiper"
      >
        {allProducts &&
          allProducts
            ?.filter((f) => f.summary === "products")
            ?.map((item, index) => {
              let m = tbldata.filter((data) => {
                return data.id === item.id;
              })[0];
              return (
                <SwiperSlide key={index}>
                  <div
                    className="left"
                    style={{
                      backgroundImage: `url(${window.Configs["ui-base-url"]}/Api/V1/ui/Content/Image?entityName=0&imageName=${item?.image})`,
                    }}
                  >
                    <div className="content">
                      <img src="/pic/logo.png" alt="logo" />
                      <p>محصولات ما</p>
                    </div>
                  </div>
                  <div
                    className="right"
                    style={{
                      backgroundColor: `${
                        JSON.parse(item?.specification)?.filter(
                          (f) => f.Key === "bg"
                        )[0].Value
                      }`,
                    }}
                  >
                    <div className="pagination">
                      <p>{index + 1}</p>
                      <p>/</p>
                      <p>
                        {allProducts &&
                          allProducts?.filter((f) => f.summary === "products")
                            ?.length}
                      </p>
                    </div>
                    <div className="title">
                      <p>{item?.title}</p>
                    </div>
                    <div className="description">
                      <p>
                        {
                          JSON.parse(item?.specification)?.filter(
                            (f) => f.Key === "description"
                          )[0].Value
                        }
                      </p>
                    </div>
                    <div className="flour-type">
                     
                      {JSON.parse(item?.specification)
                        ?.filter((f) => f.Key === "type")
                        ?.map((i, ind) => {
                          return <p key={ind}>{i.Value}</p>;
                        })}
                    </div>

                    <div className="button-container">
                      <Button
                        onClick={() => NavigateHandler("/products", index)}
                      >
                        مشاهده بیشتر
                      </Button>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
      </Swiper>
    </div>
  );
};

export default ProductsHome;
